/* Preserve exact Device selection on native (non-combined) product templates. */
(() => {
  if (window.smdNativeRecommendations) { window.smdNativeRecommendations(); return; }
  const normalize = v => String(v || '').toLowerCase().replace(/\s+/g, '');
  let selected = null, productId = null;
  const update = () => {
    if (document.querySelector('smd-case-configurator')) return;
    for (const root of document.querySelectorAll('[data-smd-recommendations]')) {
      const source = root.querySelector('[data-smd-source-device]');
      if (!source) continue;
      let data; try { data = JSON.parse(source.textContent); } catch { continue; }
      const deviceIndex = data.options.indexOf('Device');
      if (deviceIndex < 0) continue;
      if (productId !== data.id) { productId = data.id; selected = null; }
      const id = selected || new URL(location.href).searchParams.get('variant') || data.selected;
      const current = data.variants.find(v => String(v.id) === String(id));
      if (!current) continue;
      const device = current.options[deviceIndex];
      for (const card of root.querySelectorAll('product-card')) {
        let target; try { target = JSON.parse(card.querySelector('[data-smd-recommendation-variants]').textContent); } catch { continue; }
        const index = target.options.indexOf('Device');
        if (index < 0) { card.hidden = true; continue; }
        const match = target.variants.find(v => normalize(v.options[index]) === normalize(device));
        card.hidden = !match;
        if (!match) continue;
        for (const link of card.querySelectorAll('a[href]')) {
          const url = new URL(link.getAttribute('href'), location.origin);
          if (url.origin !== location.origin || !url.pathname.includes('/products/')) continue;
          url.searchParams.set('variant', match.id);
          url.searchParams.set('smd_device', device);
          const incoming = new URL(location.href);
          for (const [key,value] of incoming.searchParams) if (key === 'preview_theme_id' || key.startsWith('utm_') || key === 'gclid' || key === 'fbclid') url.searchParams.set(key,value);
          const href = url.pathname + url.search + url.hash;
          if (link.getAttribute('href') !== href) link.setAttribute('href', href);
        }
      }
      const cards = [...root.querySelectorAll('product-card')];
      root.hidden = cards.length > 0 && cards.every(c => c.hidden);
    }
  };
  window.smdNativeRecommendations = update;
  document.addEventListener('variant:change', event => {
    const picker = document.querySelector('main variant-picker');
    if (!picker || picker.getAttribute('form-id') !== event.detail?.formId) return;
    selected = event.detail.variant?.id || null; update();
  });
  document.addEventListener('click', event => { if (event.target.closest('[data-smd-recommendations] a[href]')) update(); }, true);
  window.addEventListener('pageshow', update);
  new MutationObserver(update).observe(document.querySelector('main') || document.body, {childList:true, subtree:true});
  update();
})();
